import { AppPermissions } from '@shared/constants/Mapping';
import { State } from '@shared/store/reducers/Index';
import React from 'react'
import { useSelector } from 'react-redux';

interface IUseIsClaimsCPTCodesEnabledProps {
  clinicId?: number;
}
const useIsClaimsCPTCodesEnabled = (props: IUseIsClaimsCPTCodesEnabledProps): boolean => {
  const {groupId, userPermissions} = useSelector((state: State) => state.auth);
  const clinicsList = useSelector((state: State) => state.clinics.list);

  const isClaimsCPTCodesEnabled = React.useMemo(() => {
    if (!groupId) {
      return false;
    }
    if (
      userPermissions?.[groupId]?.['group']?.[
        AppPermissions.PATIENT_MENU_PERMISSIONS.PATIENT_SHARED
      ]
    ) {
      return userPermissions?.[groupId]?.['group']?.[
        AppPermissions.MENU_PERMISSIONS.CLAIMS_CPT_CODES_ENABLE
      ];
    }
    if (!props.clinicId) return false;
    const hasClinicListBeenUpdated = clinicsList.some(
      (cl: any) => cl.org_group_id === groupId
    );
    if (!hasClinicListBeenUpdated) {
      return false;
    }
    if (Array.isArray(clinicsList)) {
      const selectedClinic = clinicsList.find(
        (cl: any) => cl?.id == props.clinicId
      );
      if (selectedClinic) {
        return !!selectedClinic?.is_claim_tickets_cpt_codes_enabled;
      }
      return true;
    }
    return false;
  }, [userPermissions, groupId, clinicsList]); // eslint-disable-line react-hooks/exhaustive-deps

  return isClaimsCPTCodesEnabled;
}

export default useIsClaimsCPTCodesEnabled